/**
 * Input.js
 *
 * Input Factory Class
 * @class  Input
 *
 * @jsx React.DOM
 */

import React from 'react';
import Paper from 'components/paper/Paper';
import ClassNames from 'classnames';

export default React.createClass({

	displayName: 'Input',

	mixins: [ React.addons.LinkedStateMixin ],

	getInitialState() {
		return {
			value: null,
			depth: 1
		};
	},

	propTypes: {
		placeholder: React.PropTypes.string.isRequired,
		name: React.PropTypes.string.isRequired,
		state: React.PropTypes.string,
		type: React.PropTypes.string,
		change: React.PropTypes.func,
		label: React.PropTypes.bool,
		inverse: React.PropTypes.bool
	},

	render() {

		let state = ClassNames({
			'lui-full-input': true,
			'success': this.props.state === 'success',
			'error': this.props.state === 'error',
			'alert': this.props.state === 'alert',
			'notice': this.props.state === 'notice',
			'disabled': this.props.state === 'disabled',
			'inverse': this.props.inverse
		});

		if(this.props.label) {

			if(this.props.change) {

				// Render with label if this.props.label === true
				return (
					<Paper className="margin-bottom" depth={this.state.depth}>
						<label htmlFor={this.props.name}>{this.props.placeholder}</label>
						<input className={state} type={this.props.type} name={this.props.name} placeholder={this.props.placeholder} onChange={this.props.change} />
					</Paper>
				);

			} else {

				// Render with label if this.props.label === true
				return (
					<Paper className="margin-bottom" depth={this.state.depth}>
						<label htmlFor={this.props.name}>{this.props.placeholder}</label>
						<input className={state} type={this.props.type} name={this.props.name} placeholder={this.props.placeholder} valueLink={this.linkState(this.props.linkedState)} />
					</Paper>
				);

			}

		} else {

			if(this.props.change) {

				// Render without label if this.props.label === false
				return (
					<Paper className="margin-bottom" depth={this.state.depth}>
						<input
							className={state}
							type={this.props.type}
							name={this.props.name}
							placeholder={this.props.placeholder}
							onChange={this.props.change} />
					</Paper>
				);

			} else {

				// Render without label if this.props.label === false
				return (
					<Paper className="margin-bottom" depth={this.state.depth}>
						<input
							className={state}
							type={this.props.type}
							name={this.props.name}
							placeholder={this.props.placeholder}
							valueLink={this.linkState(this.props.linkedState)} />
					</Paper>
				);

			}


		}

	}

});




/** WEBPACK FOOTER **
 ** ./src/components/forms/input/Input.js
 **/